import { render } from "./BaseAddressForm.vue?vue&type=template&id=52ac6e6a"
import script from "./BaseAddressForm.js?vue&type=script&lang=js"
export * from "./BaseAddressForm.js?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__